// "Lead Qualified" — pichhle 7 din ka recharts line chart aur uska header.
import React, { useMemo } from "react";
import { LineChart, Line, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import styles from "./PounceQualifiedChart.module.css";
import { buildWeekSeries } from "../../../utils/pounceAgentHelpers";

// AgentAnalysis (receptionist ka "Call Volume") wala hi recharts line chart —
// wahi height, stroke aur shadow. Filter id alag rakhi hai: AgentAnalysis ka
// "shadow" id isi page pe aa jaaye to dono takraate.
const QualifiedChart = ({ days }) => (
  <div
    role="img"
    aria-label={`Qualified leads per day: ${days.map((d) => `${d.label} ${d.count}`).join(", ")}`}
  >
    <ResponsiveContainer width="100%" height={100}>
      <LineChart data={days}>
        <defs>
          <filter id="pounceQualifiedShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#6A0DAD" floodOpacity="0.4" />
          </filter>
        </defs>
        <XAxis dataKey="label" tick={{ fontSize: 12 }} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="count"
          name="Qualified"
          stroke="#6A0DAD"
          strokeWidth={2}
          dot={false}
          strokeLinecap="round"
          strokeOpacity={1}
          isAnimationActive={true}
          filter="url(#pounceQualifiedShadow)"
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

const PounceQualifiedChart = ({ qualifiedAt }) => {
  const week = useMemo(() => buildWeekSeries(qualifiedAt), [qualifiedAt]);

  return (
    <section className={styles.chartSection} aria-labelledby="pounce-qualified-title">
      <div className={styles.chartHead}>
        <h3 id="pounce-qualified-title" className={styles.chartCount}>
          {week.total} <span>Lead Qualified</span>
        </h3>
        <div className={styles.chartTrend}>
          Last 7 Days
          {week.change !== null && (
            <span className={week.change >= 0 ? styles.chartTrendUp : styles.chartTrendDown}>
              {week.change >= 0 ? "+" : ""}
              {week.change}%
            </span>
          )}
        </div>
      </div>
      <QualifiedChart days={week.days} />
    </section>
  );
};

export default PounceQualifiedChart;
